import axios from "axios";

export interface SteelTube {
  id: string | null;
  widthInMm: number;
  lengthInMm: number;
  weightInKg: number;
  feuerringFactor: number;
  priceNet: number;
  vat: number;
}

export interface SteelTubeCalcResult {
  totalWeightInKg: number;
  priceGross: number;
  priceNet: number;
  vat: number;
  vatValue: number;
  feuerringFactor: number;
  feuerringFactorValue: number;
  customerPriceNet: number;
  customerPriceGross: number;
}

interface SteelTubeApi {
  list(): Promise<SteelTube[]>;
  add(steelTube: SteelTube): Promise<SteelTube>;
  edit(steelTube: SteelTube): Promise<SteelTube>;
  delete(steelTube: SteelTube): Promise<void>;
  calc(lengthInMm: number, widthInMm: number, marginInMm: number,): Promise<SteelTubeCalcResult>;
}

export const steelTubeApi: SteelTubeApi = {
  async list() {
    return (await axios.get("/api/calculations/steel-tubes")).data;
  },
  async edit(steelTube) {
    return await axios.put(`/api/calculations/steel-tubes/${steelTube.id}`, steelTube);
  },
  async add(steelTube) {
    return (await axios.post("/api/calculations/steel-tubes", steelTube)).data;
  },
  async delete(steelTube) {
    return await axios.delete(`/api/calculations/steel-tubes/${steelTube.id}`);
  },
  async calc(lengthInMm, widthInMm, marginInMm) {
    return (await axios.get(`/api/calculations/steel-tubes/calc?lengthInMm=${lengthInMm}&widthInMm=${widthInMm}&marginInMm=${marginInMm}`)).data;
  },
};